// ============================================================================
// HINDI TRANSLATIONS - CHAPTER 7: पत्र और प्रकाशितवाक्य
// ============================================================================
// स्तर 79-91 (13 स्तर, 39 प्रश्न)

export const chapter7Translations = {
  name: "पत्र और प्रकाशितवाक्य",
  description: "जो जय पाए वह इन सब का अधिकारी होगा... ऊपर की बुद्धि समझ को पवित्र करती है",
  
  spiritualWisdom: {
    principle: "ऊपर की बुद्धि समझ को पवित्र करती है और आत्मा को जीवित करती है",
    scripture: "पर यदि तुम में से किसी को बुद्धि की घटी हो, तो परमेश्वर से माँगे (याकूब 1:5)",
    application: "हर प्रेरितिक पत्र और प्रकाशितवाक्य का हर दर्शन हमारी समझ को समृद्ध करता है और हमारी आशा को मजबूत करता है"
  },
  
  levels: {
    79: {
      name: "यरूशलेम में गिरफ्तारी",
      challenge: "मैं न केवल बाँधे जाने वरन् यरूशलेम में मरने को भी तैयार हूँ...",
      easy: {
        question: "पौलुस को उसकी अंतिम यात्रा में कहाँ गिरफ्तार किया गया?",
        options: ["अन्ताकिया", "इफिसुस", "यरूशलेम", "कुरिन्थुस"],
        correctAnswer: 2,
        hint: "वह पवित्र शहर जो अक्सर भविष्यद्वक्ताओं को सताता था",
        funFact: "🏛️ यरूशलेम: परमेश्वर के सभी सेवकों के लिए महिमा और पीड़ा का स्थान!"
      },
      medium: {
        question: "यहूदियों ने पौलुस पर क्या आरोप लगाया?",
        options: [
          "मंदिर से चोरी",
          "अन्यजातियों को लाकर मंदिर को अपवित्र करना",
          "मूसा के विरुद्ध निन्दा",
          "रोम के विरुद्ध विद्रोह"
        ],
        correctAnswer: 1,
        hint: "सुसमाचार की सार्वभौमिकता से संबंधित आरोप",
        funFact: "⛪ विडंबना: पौलुस पर उस मंदिर को अपवित्र करने का आरोप जिसे वह गहराई से सम्मान देता था!"
      },
      hard: {
        question: "पौलुस ने अपनी कैद को अवसर में कैसे बदला?",
        options: [
          "वह भाग गया",
          "अधिकारियों के सामने गवाही दी और अपने पत्र लिखे",
          "चुप रहा",
          "अपनी रिहाई के लिए बातचीत की"
        ],
        correctAnswer: 1,
        hint: "परीक्षा को गवाही में बदलने के बारे में है",
        funFact: "⛓️ शारीरिक जंजीरें, आत्मिक स्वतंत्रता - विश्वास की शक्तिशाली गवाही!"
      }
    },
    
    80: {
      name: "राज्यपाल फेलिक्स के सामने",
      challenge: "जब वह धार्मिकता, संयम और आनेवाले न्याय की चर्चा कर रहा था...",
      easy: {
        question: "पौलुस ने किस राज्यपाल के सामने अपने विश्वास की गवाही दी?",
        options: ["पिलातुस", "फेलिक्स", "फेस्तुस", "गलियो"],
        correctAnswer: 1,
        hint: "अपने लालच के लिए जाना जाने वाला राज्यपाल",
        funFact: "⚖️ फेलिक्स रिश्वत की उम्मीद कर रहा था - भ्रष्टाचार बनाम सत्यनिष्ठा!"
      },
      medium: {
        question: "पौलुस के संदेश पर फेलिक्स की क्या प्रतिक्रिया थी?",
        options: [
          "वह परिवर्तित हो गया",
          "वह डर से काँप उठा",
          "उसने उपहास किया",
          "वह उदासीन रहा"
        ],
        correctAnswer: 1,
        hint: "सत्य से व्याकुल विवेक",
        funFact: "😰 भ्रष्ट लोग भी दैवीय सत्य के सामने काँपते हैं - सार्वभौमिक विवेक!"
      },
      hard: {
        question: "फेलिक्स ने पौलुस को दो साल तक कैदी क्यों रखा?",
        options: [
          "उसकी रक्षा करने के लिए",
          "राजनीतिक हित और भ्रष्टाचार की आशा से",
          "भूल जाने से",
          "विश्वास से"
        ],
        correctAnswer: 1,
        hint: "राजनीतिक और व्यक्तिगत गणनाओं के बारे में है",
        funFact: "🏛️ भ्रष्ट मानवीय न्याय बनाम सिद्ध दैवीय न्याय - स्पष्ट विरोधाभास!"
      }
    },

    81: {
      name: "कैसर को अपील",
      challenge: "मैं कैसर की दोहाई देता हूँ!",
      easy: {
        question: "पौलुस ने यरूशलेम में मुकदमे से बचने के लिए किस अधिकार का सहारा लिया?",
        options: [
          "शरण का अधिकार",
          "कैसर को अपील (रोमी नागरिक)",
          "पलायन का अधिकार",
          "राजनयिक सुरक्षा"
        ],
        correctAnswer: 1,
        hint: "उसकी रोमी नागरिकता का विशेषाधिकार",
        funFact: "🏛️ रोमी नागरिकता: सुसमाचार को रोम ले जाने के लिए दैवीय पासपोर्ट!"
      },
      medium: {
        question: "पौलुस ने प्रस्थान से पहले किसके सामने गवाही दी?",
        options: [
          "महासभा",
          "राजा अग्रिप्पा और बिरनीके",
          "रोमी सैनिक",
          "यहूदी भीड़"
        ],
        correctAnswer: 1,
        hint: "यहूदीकृत हेरोदेस का राज्य",
        funFact: "👑 भेड़ के चरवाहे से शाही महल तक - पौलुस का दैवीय उत्थान!"
      },
      hard: {
        question: "परमेश्वर अपनी योजनाओं के लिए मानवीय प्रणालियों का उपयोग कैसे करता है?",
        options: [
          "वह उन्हें नजरअंदाज करता है",
          "अपने उद्देश्यों को पूरा करने के लिए उन्हें दैवीय रूप से उपयोग करता है",
          "वह उन्हें नष्ट कर देता है",
          "वह हमेशा उनका विरोध करता है"
        ],
        correctAnswer: 1,
        hint: "इतिहास पर दैवीय संप्रभुता के बारे में है",
        funFact: "🌐 रोमी न्याय सुसमाचार का वाहन बन जाता है - उल्लेखनीय प्रावधान!"
      }
    },

    82: {
      name: "माल्टा में जहाज़ की तबाही",
      challenge: "हे पौलुस, मत डर; तुझे कैसर के सामने खड़ा होना अवश्य है...",
      easy: {
        question: "पौलुस किस द्वीप पर जहाज़ की तबाही का शिकार हुआ?",
        options: ["क्रेते", "साइप्रस", "माल्टा", "सिसली"],
        correctAnswer: 2,
        hint: "सिसली के दक्षिण में छोटा द्वीप",
        funFact: "🏝️ माल्टा: मजबूर ठहराव फलदायी मिशन बन जाता है - दैवीय मोड़!"
      },
      medium: {
        question: "पौलुस ने माल्टा में कौन सा चमत्कार किया?",
        options: [
          "तूफान को शांत किया",
          "पुबलियुस के पिता और अन्य बीमारों को चंगा किया",
          "भोजन बढ़ाया",
          "मृतक को जीवित किया"
        ],
        correctAnswer: 1,
        hint: "द्वीप पर कई चंगाईयाँ",
        funFact: "🏥 पौलुस: जहाज़ की तबाही के शिकार से चमत्कारी चिकित्सक तक - दैवीय प्रतिष्ठा!"
      },
      hard: {
        question: "यह जहाज़ की तबाही परमेश्वर की विश्वसनीयता को कैसे दर्शाती है?",
        options: [
          "दुर्घटनाएँ होती हैं",
          "परमेश्वर बाधाओं के बावजूद रक्षा करता है और अपनी प्रतिज्ञाएँ पूरी करता है",
          "पौलुस भाग्यशाली था",
          "यह टाला जा सकता था"
        ],
        correctAnswer: 1,
        hint: "प्रतिज्ञाओं के प्रति दैवीय विश्वसनीयता के बारे में है",
        funFact: "⛈️ तूफान, जहाज़ की तबाही, साँप: कुछ भी पौलुस के लिए दैवीय योजना को नहीं रोकता!"
      }
    },

    83: {
      name: "पौलुस रोम में",
      challenge: "वह पूरे दो वर्ष अपने किराए के घर में रहा...",
      easy: {
        question: "पौलुस रोम में किन परिस्थितियों में रहा?",
        options: [
          "बंद जेल में",
          "गृह कारावास में",
          "पूर्ण स्वतंत्रता में",
          "निर्वासन में"
        ],
        correctAnswer: 1,
        hint: "निगरानी के तहत सापेक्ष स्वतंत्रता",
        funFact: "🏠 घर-जेल मिशनरी केंद्र बन जाता है - जंजीरों में स्वतंत्रता!"
      },
      medium: {
        question: "पौलुस ने रोम में अपने दो वर्षों के दौरान क्या किया?",
        options: [
          "आराम किया",
          "सिखाया और अपने पत्र लिखे",
          "अपना बचाव तैयार किया",
          "पर्यटन किया"
        ],
        correctAnswer: 1,
        hint: "जंजीरों के बावजूद गहन सेवकाई",
        funFact: "✍️ कारावास के पत्र: इफिसियों, फिलिप्पियों, कुलुस्सियों, फिलेमोन!"
      },
      hard: {
        question: "परंपरा के अनुसार पौलुस ने अपनी सेवकाई कैसे समाप्त की?",
        options: [
          "बीमारी से मर गया",
          "लगभग 67 ई. में नीरो के तहत सिर काट दिया गया",
          "बुढ़ापे में मर गया",
          "रहस्यमय तरीके से गायब हो गया"
        ],
        correctAnswer: 1,
        hint: "पागल सम्राट के तहत शहादत",
        funFact: "⚔️ 'मैंने अच्छी कुश्ती लड़ी है, मैंने दौड़ पूरी की है' - अंतिम विजय!"
      }
    },

    84: {
      name: "रोमियों के नाम पत्र",
      challenge: "मैं सुसमाचार से नहीं लजाता, क्योंकि वह उद्धार के लिए परमेश्वर की सामर्थ्य है...",
      easy: {
        question: "कौन सा पत्र विश्वास द्वारा उद्धार के सिद्धांत को सबसे अधिक विकसित करता है?",
        options: ["1 कुरिन्थियों", "गलातियों", "रोमियों", "इफिसियों"],
        correctAnswer: 2,
        hint: "पौलुस का धर्मशास्त्रीय 'गिरजाघर'",
        funFact: "🏛️ रोमियों: धर्मशास्त्रीय उत्कृष्ट कृति जिसने अगस्टीन और लूथर को परिवर्तित किया!"
      },
      medium: {
        question: "रोमियों के अनुसार, मनुष्य परमेश्वर के सामने कैसे धर्मी ठहराया जाता है?",
        options: [
          "अपने भले कामों से",
          "केवल विश्वास से, कामों के बिना",
          "बलिदानों से",
          "परंपरा से"
        ],
        correctAnswer: 1,
        hint: "सुधार का मूल सिद्धांत",
        funFact: "⚖️ 'धर्मी जन विश्वास से जीवित रहेगा' - पौलुस की आत्मिक क्रांति!"
      },
      hard: {
        question: "इस पत्र की सार्वभौमिक पहुँच क्या है?",
        options: [
          "यह केवल रोमियों से संबंधित है",
          "यह सभी मानवता के लिए उद्धार की योजना को प्रस्तुत करता है",
          "यह केवल रोम की आलोचना करता है",
          "यह पुराना है"
        ],
        correctAnswer: 1,
        hint: "सार्वभौमिक उद्धार योजना के बारे में है",
        funFact: "🌍 सुसमाचार = सभी के लिए परमेश्वर की सामर्थ्य: यहूदी और यूनानी - संपूर्ण सार्वभौमिकता!"
      }
    },

    85: {
      name: "प्रेम का गीत - 1 कुरिन्थियों 13",
      challenge: "यदि मैं मनुष्यों और स्वर्गदूतों की बोलियाँ बोलूँ, और प्रेम न रखूँ...",
      easy: {
        question: "बाइबल के किस अध्याय को 'प्रेम का गीत' कहा जाता है?",
        options: [
          "1 कुरिन्थियों 12",
          "1 कुरिन्थियों 13",
          "1 यूहन्ना 4",
          "रोमियों 8"
        ],
        correctAnswer: 1,
        hint: "1 कुरिन्थियों का केंद्रीय अध्याय",
        funFact: "💝 विवाहों में सबसे अधिक पढ़ा जाने वाला अध्याय - प्रेम की सिद्ध परिभाषा!"
      },
      medium: {
        question: "पौलुस प्रेम की अवधि के बारे में क्या कहता है?",
        options: [
          "प्रेम समय के साथ समाप्त हो जाता है",
          "प्रेम कभी टलता नहीं",
          "प्रेम परिस्थितियों पर निर्भर करता है",
          "प्रेम अस्थायी है"
        ],
        correctAnswer: 1,
        hint: "दैवीय प्रेम की शाश्वतता",
        funFact: "♾️ केवल प्रेम ही मृत्यु और अनंतता को पार करता है - सर्वोच्च मूल्य!"
      },
      hard: {
        question: "पौलुस प्रेम को आत्मिक वरदानों से ऊपर क्यों रखता है?",
        options: [
          "वरदान बुरे हैं",
          "प्रेम बाकी सब कुछ को अर्थ और मूल्य देता है",
          "प्रेम आसान है",
          "वरदान विभाजित करते हैं"
        ],
        correctAnswer: 1,
        hint: "सभी सेवा के प्रेरक और अर्थ के बारे में है",
        funFact: "🎯 प्रेम के बिना, सबसे बड़े वरदान भी शोर और घमंड बन जाते हैं!"
      }
    },

    86: {
      name: "इफिसियों: मसीह की देह के रूप में कलीसिया",
      challenge: "सब कुछ उसके पाँवों तले कर दिया, और उसे सब वस्तुओं पर शिरोमणि ठहराकर कलीसिया को दे दिया...",
      easy: {
        question: "इफिसियों के अनुसार, मसीह के साथ अपने संबंध में कलीसिया क्या है?",
        options: [
          "उसका मंदिर",
          "उसकी देह",
          "उसका परिवार",
          "उसकी सेना"
        ],
        correctAnswer: 1,
        hint: "एकता का जैविक रूपक",
        funFact: "👤 मसीह की देह: हर मसीही एक महत्वपूर्ण अंग है - परस्पर निर्भरता!"
      },
      medium: {
        question: "पौलुस आत्मिक युद्ध के लिए किस हथियार का वर्णन करता है?",
        options: [
          "भौतिक कवच",
          "परमेश्वर का सारा हथियार: सत्य, धार्मिकता, शांति, विश्वास, उद्धार, वचन",
          "रोमी कवच",
          "जादुई सुरक्षा"
        ],
        correctAnswer: 1,
        hint: "आत्मिक कवच के छह भाग",
        funFact: "⚔️ आत्मिक हथियारों से आत्मिक युद्ध - विजय की दैवीय रणनीति!"
      },
      hard: {
        question: "पौलुस के अनुसार हमारा वास्तविक संघर्ष किसके विरुद्ध है?",
        options: [
          "दुष्ट मनुष्यों के विरुद्ध",
          "दुष्टता की आत्मिक शक्तियों के विरुद्ध",
          "सरकारों के विरुद्ध",
          "गरीबी के विरुद्ध"
        ],
        correctAnswer: 1,
        hint: "अदृश्य आत्मिक शक्तियों के बारे में है",
        funFact: "👹 लौकिक युद्ध: मानवीय संघर्षों के पीछे, वास्तविक आत्मिक युद्ध!"
      }
    },

    87: {
      name: "फिलिप्पियों: परीक्षा में आनन्द",
      challenge: "प्रभु में सदा आनन्दित रहो, मैं फिर कहता हूँ, आनन्दित रहो!",
      easy: {
        question: "पौलुस अपनी कैद के बावजूद किस भावना को प्रोत्साहित करता है?",
        options: ["समर्पण", "आनन्द", "क्रोध", "उदासी"],
        correctAnswer: 1,
        hint: "एक कैदी के लिए आश्चर्यजनक भावना",
        funFact: "😊 4 अध्यायों में 16 बार आनन्द - जेल में खुशी का रिकॉर्ड!"
      },
      medium: {
        question: "फिलिप्पियों 2 के अनुसार, यीशु ने कौन सा रवैया अपनाया?",
        options: [
          "उसने बल से थोपा",
          "उसने अपने आप को खाली और दीन किया यहाँ तक कि मृत्यु तक",
          "वह अपनी जिम्मेदारियों से भाग गया",
          "उसने महिमा की खोज की"
        ],
        correctAnswer: 1,
        hint: "स्वैच्छिक अधोमुखी आंदोलन",
        funFact: "📉 यीशु: परमेश्वर के साथ समानता से क्रूस पर मृत्यु तक - चरम प्रेम!"
      },
      hard: {
        question: "पौलुस जेल में आनन्द का प्रचार कैसे कर सकता है?",
        options: [
          "वह दिखावा कर रहा है",
          "मसीही आनन्द परिस्थितियों से परे है",
          "वह पीड़ाप्रिय है",
          "वह वास्तविकता से इनकार करता है"
        ],
        correctAnswer: 1,
        hint: "अलौकिक आनन्द के बारे में है",
        funFact: "✨ आनन्द = परिस्थितियों से स्वतंत्र आत्मा का फल - दैवीय रहस्य!"
      }
    },

    88: {
      name: "पास्टरल पत्र",
      challenge: "विश्वास की अच्छी कुश्ती लड़, अनन्त जीवन को धर ले...",
      easy: {
        question: "पौलुस ने अपने अंतिम पास्टरल पत्र किसे लिखे?",
        options: [
          "कुरिन्थियों को",
          "तीमुथियुस और तीतुस को",
          "रोमियों को",
          "गलातियों को"
        ],
        correctAnswer: 1,
        hint: "उसके आत्मिक पुत्र और सहकर्मी",
        funFact: "👨‍👦 आत्मिक वसीयत: पौलुस अगली पीढ़ी को मशाल सौंपता है!"
      },
      medium: {
        question: "पौलुस कलीसिया के अगुवों को चुनने के लिए क्या सलाह देता है?",
        options: [
          "सबसे अमीर को चुनें",
          "सख्त नैतिक और आत्मिक मानदंडों के अनुसार चुनें",
          "सबसे शिक्षित को चुनें",
          "सबसे लोकप्रिय को चुनें"
        ],
        correctAnswer: 1,
        hint: "सबसे पहले नैतिक योग्यताएँ",
        funFact: "⚖️ अगुवों के लिए उच्च मानक: योग्यता से पहले चरित्र - दैवीय प्राथमिकताएँ!"
      },
      hard: {
        question: "पौलुस तीमुथियुस को क्या विरासत छोड़ता है?",
        options: [
          "भौतिक संपत्ति",
          "सुसमाचार के प्रति विश्वासयोग्यता और पास्टरल सेवकाई",
          "राजनीतिक पद",
          "धर्मशास्त्रीय स्कूल"
        ],
        correctAnswer: 1,
        hint: "आत्मिक विरासत के बारे में है",
        funFact: "📜  'अच्छी थाती की रक्षा कर' - युगों तक सुसमाचार का विश्वासयोग्य संचरण!"
      }
    },

    89: {
      name: "इब्रानियों: यीशु महायाजक",
      challenge: "हमारा ऐसा महायाजक है, जो स्वर्गों में जा पहुँचा है...",
      easy: {
        question: "इब्रानियों के अनुसार, हमारा महायाजक कौन है?",
        options: ["हारून", "मूसा", "यीशु", "मलिकिसिदक"],
        correctAnswer: 2,
        hint: "परमेश्वर और मनुष्यों के बीच सिद्ध मध्यस्थ",
        funFact: "✝️ यीशु: याजक और बलिदान - सदा के लिए एक बार का सिद्ध बलिदान!"
      },
      medium: {
        question: "यीशु का याजकपद हारून के याजकपद से श्रेष्ठ क्यों है?",
        options: [
          "यह पुराना है",
          "यह मलिकिसिदक की रीति पर अनन्त है",
          "यह अमीर है",
          "यह लोकप्रिय है"
        ],
        correctAnswer: 1,
        hint: "अनंतता बनाम अस्थायीता",
        funFact: "♾️ अनन्त याजकपद: यीशु हमारे लिए सदा मध्यस्थता करता है!"
      },
      hard: {
        question: "इब्रानियों नई वाचा को कैसे प्रस्तुत करता है?",
        options: [
          "पुरानी के समान",
          "श्रेष्ठ और अंतिम, हृदयों में लिखी",
          "अस्थायी",
          "वैकल्पिक"
        ],
        correctAnswer: 1,
        hint: "पूर्ति और अतिक्रमण के बारे में है",
        funFact: "📋 नई वाचा: हृदयों में लिखी व्यवस्था, पत्थर पर नहीं!"
      }
    },

    90: {
      name: "याकूब: विश्वास और कर्म",
      challenge: "विश्वास कर्मों बिना मरा हुआ है...",
      easy: {
        question: "याकूब के अनुसार, विश्वास के साथ क्या होना चाहिए?",
        options: [
          "शब्द",
          "कर्म",
          "भावनाएँ",
          "ज्ञान"
        ],
        correctAnswer: 1,
        hint: "विश्वास की व्यावहारिक अभिव्यक्ति",
        funFact: "🌳 विश्वास = जड़, कर्म = फल - संपूर्ण आत्मिक वृक्ष!"
      },
      medium: {
        question: "याकूब जीभ की तुलना किससे करता है?",
        options: [
          "तलवार से",
          "छोटी सी आग से जो बड़े जंगल को जला देती है",
          "संगीत वाद्ययंत्र से",
          "उपकरण से"
        ],
        correctAnswer: 1,
        hint: "छोटा अंग लेकिन बड़ी विनाशकारी शक्ति",
        funFact: "🔥 जीभ: छोटा अंग लेकिन पूरे जीवन को जला सकती है - सावधानी!"
      },
      hard: {
        question: "हम याकूब और पौलुस को विश्वास/कर्मों पर कैसे सुलझाएँ?",
        options: [
          "वे विरोधाभासी हैं",
          "पौलुस धर्मीकरण की बात करता है, याकूब पवित्रीकरण की",
          "एक गलत है",
          "कोई समाधान नहीं है"
        ],
        correctAnswer: 1,
        hint: "दो पूरक पहलुओं के बारे में है",
        funFact: "⚖️ पौलुस: विश्वास से बचाए गए / याकूब: कर्मों से सिद्ध विश्वास - सिद्ध सामंजस्य!"
      }
    },

    91: {
      name: "प्रकाशितवाक्य: राजा की वापसी",
      challenge: "देख, मैं शीघ्र आनेवाला हूँ; धन्य है वह, जो इस पुस्तक की भविष्यद्वाणी की बातें सुन रखता है!",
      easy: {
        question: "प्रकाशितवाक्य में यूहन्ना कितनी कलीसियाओं को लिखता है?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "सिद्धता की संख्या",
        funFact: "⛪ एशिया की 7 कलीसियाएँ: सभी समयों की सभी कलीसियाओं का दर्पण!"
      },
      medium: {
        question: "प्रकाशितवाक्य के अनुसार कहानी कैसे समाप्त होती है?",
        options: [
          "कुल विनाश",
          "नया आकाश और नई पृथ्वी",
          "स्वर्गीय स्वर्ग में वापसी",
          "सभी अस्तित्व का अंत"
        ],
        correctAnswer: 1,
        hint: "सृष्टि का संपूर्ण नवीनीकरण",
        funFact: "🌅 दुनिया का अंत नहीं बल्कि कुल नवीनीकरण - परम आशा!"
      },
      hard: {
        question: "प्रकाशितवाक्य सताए गए लोगों को क्या केंद्रीय संदेश देता है?",
        options: [
          "समर्पण करो",
          "मसीह राज्य करता है और अंततः विजयी होगा",
          "उत्पीड़न से भागो",
          "बदला लो"
        ],
        correctAnswer: 1,
        hint: "अंतिम विजय में आशा के बारे में है",
        funFact: "👑  'जो था और जो है और जो आनेवाला है' - इतिहास और समय का प्रभु!"
      }
    }
  }
};

export default chapter7Translations;
